let body = document.querySelector('body');
let overlay = document.getElementById('overlay');
let openModalMenu = document.getElementById('openModalMenu');
let modalIconClose = document.getElementById('modalIconClose');
let mainConfButton = document.getElementById('mainConfButton');
let searchFilm = document.querySelector('.search_film');
let mainModalContent = document.querySelector('#mainModalContent');
let modalContentConf = document.querySelector('#modalContentConf');
let mainSearchModal = document.querySelector('#mainSearchModal');

document.querySelector('#mainSearchButton').addEventListener('click', (event) => {
    body.classList.add("open_modal");
    mainModalContent.style.display = 'none';
    modalContentConf.style.display = 'none';
    mainSearchModal.style.display = 'block';
    event.preventDefault();


    if (body.classList.contains('animateOff')) {
        overlay.style.display = 'block';
        overlay.style.opacity = 1;

        openModalMenu.style.display = 'block';
        openModalMenu.style.opacity = 1;
        searchFilm.focus();
    } else {
        overlay.style.transition = 'opacity 0.4s';
        overlay.style.opacity = 0;
        overlay.style.display = 'block';

        setTimeout(function () {
            overlay.style.opacity = 1;
            openModalMenu.style.display = 'block';
            openModalMenu.style.transition = 'opacity 0.2s';
            openModalMenu.style.opacity = 1;
            searchFilm.focus();
        }, 0);
    }
});

function closeModal() {
    if (body.classList.contains('animateOff')) {
        openModalMenu.style.opacity = 0;
        openModalMenu.style.display = 'none';
        overlay.style.display = 'none';
    } else {
        openModalMenu.style.transition = 'opacity 0.2s';
        openModalMenu.style.opacity = 0;

        setTimeout(function() {
            openModalMenu.style.display = 'none';
        }, 200);

        overlay.style.transition = 'opacity 0.4s';
        overlay.style.opacity = 0;

        setTimeout(function() {
            overlay.style.display = 'none';
        }, 400);
    }
    body.classList.remove('open_modal');
}

modalIconClose.addEventListener('click', closeModal);
overlay.addEventListener('click', closeModal);

mainConfButton.addEventListener('click', function(event) {
    event.preventDefault();
    body.classList.add('open_modal');
    mainModalContent.style.display = 'none';
    mainSearchModal.style.display = 'none';
    modalContentConf.style.display = 'block';

    if (body.classList.contains('animateOff')) {
        overlay.style.display = 'block';
        overlay.style.opacity = 1;

        openModalMenu.style.display = 'block';
        openModalMenu.style.opacity = 1;
        modalIconClose.focus();
    } else {
        overlay.style.transition = 'opacity 0.4s';
        overlay.style.opacity = 0;
        overlay.style.display = 'block';

        setTimeout(function() {
            overlay.style.opacity = 1;
            openModalMenu.style.display = 'block';
            openModalMenu.style.transition = 'opacity 0.2s';
            openModalMenu.style.opacity = 1;
            modalIconClose.focus();
        }, 0);
    }
});

// modal conf
let firstFocusElem = document.getElementById('firstFocus');
let lastFocusOneElem = document.getElementById('lastFocusOne');
let lastFocusTwoElem = document.getElementById('lastFocusTwo');
let lastFocusThreeElem = document.getElementById('lastFocusThree');
let openModalConf = document.getElementById('openModalConf');
let mainSearchButton = document.getElementById('mainSearchButton');
let buttonConf2 = document.getElementById('buttonConf2');
let changeLanguageButtons = document.querySelectorAll('.changeLanguage');
let animationOff = document.getElementById('animationOff');
let button2Conf = document.querySelector('.button2_conf');
let button1Conf = document.querySelector('.button1_conf');

function focusElement(selector) {
    let elem = document.querySelector(selector);
    if (elem) elem.focus();
}

function displayElement(selector, displayStyle) {
    let elem = document.querySelector(selector);
    if (elem) elem.style.display = displayStyle;
}

function setOpacity(elem, opacity, duration) {
    elem.style.transition = `opacity ${duration}ms`;
    elem.style.opacity = opacity;
}

function fadeIn(elem, duration, callback) {
    elem.style.display = 'block';
    setOpacity(elem, 1, duration);
    if (callback) setTimeout(callback, duration);
}

firstFocusElem.addEventListener('focus', function() {
    focusElement('#searchInput');
    focusElement('#buttonConf2 .button5_conf button');
});

lastFocusOneElem.addEventListener('focus', function() {
    focusElement('#modalIconClose');
});

lastFocusTwoElem.addEventListener('focus', function() {
    focusElement('#modalIconClose');
});

lastFocusThreeElem.addEventListener('focus', function() {
    focusElement('#modalIconClose');
});

openModalConf.addEventListener('click', function(event) {
    event.preventDefault();
    displayElement('#mainModalContent', 'none');
    displayElement('#modalContentConf', 'block');
    focusElement('#modalIconClose');
});

mainSearchButton.addEventListener('click', function(event) {
    event.preventDefault();
    body.classList.add('open_modal');
    displayElement('#mainModalContent', 'none');
    displayElement('#modalContentConf', 'none');
    displayElement('#mainSearchModal', 'block');

    if (body.classList.contains('animateOff')) {
        fadeIn(overlay, 0, function() {
            displayElement('#openModalMenu', 'block');
            setOpacity(openModalMenu, 1, 0);
            focusElement('.search_film');
        });
    } else {
        fadeIn(overlay, 400, function() {
            displayElement('#openModalMenu', 'block');
            setOpacity(openModalMenu, 1, 200);
            focusElement('.search_film');
        });
    }
});

buttonConf2.querySelectorAll('div').forEach(function(div) {
    div.addEventListener('click', function() {
        buttonConf2.querySelectorAll('div').forEach(function(d) {
            d.classList.remove('active');
        });
        div.classList.add('active');
    });
});

changeLanguageButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
        event.preventDefault();
        changeLanguageButtons.forEach(function(btn) {
            btn.classList.remove('active');
        });
        button.classList.add('active');
    });
});

animationOff.classList.remove('active');
animationOff.addEventListener('click', function() {
    if (animationOff.classList.contains('active')) {
        animationOff.textContent = turnOn;
        animationOff.classList.remove('active');
        body.classList.remove('animateOff');
        // Cookies.remove('animate');
    } else {
        animationOff.textContent = turnOff;
        animationOff.classList.add('active');
        body.classList.add('animateOff');
        // Cookies.set('animate', true);
    }
});

// if (Cookies.get('animate')) {
//     body.classList.add('animateOff');
// }

button2Conf.addEventListener('click', function() {
    body.classList.add('contrastVersion2');
    // Cookies.set('contrastVersion', true);
});

button1Conf.addEventListener('click', function() {
    body.classList.remove('contrastVersion2');
    // Cookies.remove('contrastVersion');
});

// if (Cookies.get('contrastVersion')) {
//     body.classList.add('contrastVersion2');
// }

if (body.classList.contains('contrastVersion2')) {
    button2Conf.classList.add('active');
    button1Conf.classList.remove('active');
} else {
    button2Conf.classList.remove('active');
    button1Conf.classList.add('active');
}

button2Conf.addEventListener('click', function() {
    if (body.classList.contains('contrastVersion2')) {
        displayElement('.header .home .original', 'none');
        displayElement('.header .home .contrast', 'block');
        displayElement('.header .logo .original', 'none');
        displayElement('.header .logo .contrast', 'block');
    }
});

button1Conf.addEventListener('click', function() {
    if (!body.classList.contains('contrastVersion2')) {
        displayElement('.header .home .original', 'block');
        displayElement('.header .home .contrast', 'none');
        displayElement('.header .logo .original', 'block');
        displayElement('.header .logo .contrast', 'none');
    }
});
